import md5 from "md5";

export const generateSeeds = () => {
  const aid = window.clientConfig.token;
  const md5TokenCombinations = combinations(md5(aid));

  return md5TokenCombinations;
};

function combinations(str) {
  const arr = str.split("");
  const combinations = [];
  
  arr.forEach((v, index) => {
    if (index <= arr.length - 4) {
      combinations.push((parseInt(arr.slice(index, index + 4).join(""), 16)));
    }
  })

  return combinations;
};